package de.ohhhmhhh.backend.sdk

import io.ktor.client.engine.*
import io.ktor.client.engine.js.*

actual val ENGINE: HttpClientEngineFactory<HttpClientEngineConfig>
    get() = Js